import isEqual from 'lodash.isequal';
import { useEffect, type Dispatch, type SetStateAction } from 'react';
import { useForm } from 'react-final-form';

// Compare `values` and `initialValues` since they both survive unmounting.
// Final-form's dirtyFields doesn't work for our multi-page value checks.
export function useSyncEditedLogEntryIds(
  setEditedLogEntryIds: Dispatch<SetStateAction<Set<string>>> | undefined,
  allLogEntryIds: string[],
) {
  const form = useForm();

  useEffect(() => {
    if (!setEditedLogEntryIds) return undefined;

    return form.subscribe(
      () => {
        const { initialValues, values } = form.getState();

        setEditedLogEntryIds((previousIds) => {
          const nextIds = new Set(
            allLogEntryIds.filter(
              (id) => !isEqual(values?.[id], initialValues?.[id]),
            ),
          );
          return isEqual(previousIds, nextIds) ? previousIds : nextIds;
        });
      },
      { dirtyFields: true },
    );
  }, [form, allLogEntryIds, setEditedLogEntryIds]);
}
